import { DELETE_SURGE_EVENT, DELETE_SURGE_EVENT_SUCCESS, DELETE_SURGE_EVENT_ERROR, DELETE_SURGE_EVENT_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DeleteEvent = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_SURGE_EVENT:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DELETE_SURGE_EVENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DELETE_SURGE_EVENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DELETE_SURGE_EVENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DeleteEvent;
